import { render, staticRenderFns } from "./AddRelateList.vue?vue&type=template&id=781c3096&scoped=true"
import script from "./AddRelateList.vue?vue&type=script&lang=js"
export * from "./AddRelateList.vue?vue&type=script&lang=js"
import style0 from "./AddRelateList.vue?vue&type=style&index=0&id=781c3096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781c3096",
  null
  
)

export default component.exports